import data from "./VisitStatCardData";
import moment from "moment";

export default {
  ...data,
  props: {
    color: String,
    labelColor: String,
    labelText: String,
    currX: String,
    planX: String,
    currMT: String,
    visitPerDay: String,
    projectedVisit: String,
  },
  computed: {
    strikeRate() {
      return ((this.currX / this.planX) * 100).toFixed(1);
    },
    MTperVisit() {
      return parseFloat(
        parseFloat(this.currMT) / parseFloat(this.currX)
      ).toFixed(3);
    },
    projectedStrikeRate() {
      return parseFloat(
        (parseFloat(this.projectedVisit) / parseFloat(this.planX)) * 100
      ).toFixed(1);
    },
  },
};
